import { api } from "@/api";

export async function getTranslations(): Promise<any> {
  const res = await api.translations();
  return res;
}
